/** @param {string} ruleName */
function getRuleUrl(ruleName) {
  return "https://html-eslint.org/docs/rules/" + ruleName;
}

module.exports = {
  getRuleUrl,
};
